import { TranslationSvc } from '../services/translation.service';

/**
 * Translate directive
 * @type {{bind(*, *): (string|*)}}
 */

export const Translate = {

    bind(element, binding){

        if (!binding.value) return '';

        const value = TranslationSvc.getTranslation(binding.value);

        element.innerHTML = value ? value : '';

    }
};


// WEBPACK FOOTER //
// translate.js